export default __webpack_public_path__ + "static/media/iconPersonBlue.757cd7d6.svg";